import { Injectable } from '@angular/core';
import Highcharts from 'projects/gtw-elements/src/app/core/highcharts-init';
import * as _ from 'lodash-es';
import { DashboardDataFormatterStore } from '../models/DashboardDataFormatter';

@Injectable({
    providedIn: 'root'
})
export class DataFormatterService {

    formatterStore:DashboardDataFormatterStore = [
        {
            name:"None",//None is hardcoded at some places. Please refer them before changing here.
            func:(value: number)=> value
        },
        {
            name:"Number",
            func:(value: number,isNegative: boolean,skipHTML: boolean = false): string => {
                var format = Highcharts.numberFormat(Math.abs(value),0,'.',',');
                return (value < 0 || isNegative ?
                         skipHTML === true ?`(${format})`: `<span style="color:#e86153">(${format})</span>`
                         :format);
            }
        },
        {
            name:"Number with Label",
            func:function(value: number,isNegative: boolean,label: string): string {
                var format = Highcharts.numberFormat(Math.abs(value),0,'.',',');
                return label + ': ' + (value < 0 || isNegative ? `<span style="color:#e86153">(${format})</span>`:format);
            }
        },
        {
            name:"Percent",
            func:function(value: number,isNegative: boolean,prefix: string): string {
                var format = Highcharts.numberFormat(Math.abs(value),2,'.',',');
                return (prefix || '') + (value < 0 || isNegative? `<span style="color:#e86153">(${format}%)</span>`:format+'%');
            }
        },
        {
            name:"Amount",
            func:this.convertAmount
        },
        {
            name:"Amount with Label",
            func:this.convertAmountWithLabel
        }
    ]

    getFormatter(name: string) {
        return _.find(this.formatterStore, function(value,index) {
            return value.name === name; //&& (value.type === 'all' || value.type.includes(type));
        });
    }
    getAllFormatters() {
        return this.formatterStore;
    }

    private convertAmount(labelValue: number,isNegative: boolean) {
        let abs = Math.abs(Number(labelValue));
        // Nine Zeroes for Billions
        let result =  abs >= 1.0e+9

            ?'$' + (abs / 1.0e+9).toFixed(2) + "B"
            // Six Zeroes for Millions
            :  abs >= 1.0e+6

                ? '$' + (abs / 1.0e+6).toFixed(2) + "M"
                // Three Zeroes for Thousands
                : abs >= 1.0e+3

                    ? '$' + (abs / 1.0e+3).toFixed(2) + "K"

                    : '$' + abs.toFixed(2);

        if(labelValue < 0 || isNegative){
            return `<span style="color:#e86153"">(${result})</span>`
        }

        return isNaN(abs) ? `-`:`${result}`;
    }

    private convertAmountWithLabel(value: number,isNegative: boolean,label: string) {
        // Nine Zeroes for Billions
        let result = Math.abs(Number(value)) >= 1.0e+9

            ?'$' + (Number(value) / 1.0e+9).toFixed(2) + "B"
            // Six Zeroes for Millions
            :  Math.abs(Number(value)) >= 1.0e+6

                ?  '$' + (Number(value) / 1.0e+6).toFixed(2) + "M"
                // Three Zeroes for Thousands
                : Math.abs(Number(value)) >= 1.0e+3

                    ? '$' + (Number(value) / 1.0e+3).toFixed(2) + "K"

                    : '$' + Number(value).toFixed(2);

        if(value < 0 || isNegative){
            return `${label}: <span style="color:#e86153"">(${result})</span>`
        }

        return `${label}: ${result}`;
    }
}
